import type { ColorVariant } from '../components';
import type { ObjectValues } from '@repo/common';

import { Spacer } from '@dot/design-system';

import { ButtonsGroup, Container, Text, Title } from '../components';

type Props = {
  buttons?: React.ReactNode;
  icon: React.ReactNode;
  infoText?: string;
  subtitle?: string;
  title: string;
  titleColorVariant: ObjectValues<typeof ColorVariant>;
};

export const VerificationFailedLayout = ({ buttons, icon, infoText, subtitle, title, titleColorVariant }: Props) => {
  return (
    <Container>
      {icon}
      <Title $colorVariant={titleColorVariant} id="verification-result-title">
        {title}
      </Title>
      <Text id="verification-result-subtitle">{subtitle}</Text>
      {infoText && (
        <Spacer $top={2}>
          <Text>{infoText}</Text>
        </Spacer>
      )}
      <ButtonsGroup>{buttons}</ButtonsGroup>
    </Container>
  );
};
